import { StateCreator } from 'zustand'
import { CampaignCreationState } from '../state'

export interface Step3Slice {
    productService: string
    customProductService: string
    setProductService: (productService: string) => void
    setCustomProductService: (customProductService: string) => void
}

export const createStep3Slice: StateCreator<
    CampaignCreationState,
    [],
    [],
    Step3Slice
> = (set) => ({
    productService: '',
    customProductService: '',
    setProductService: (productService) => set({ productService }),
    setCustomProductService: (customProductService) =>
        set({ customProductService }),
})
